/**
 * SupplyProgress.jsx
 *
 * "X / 2222 MINTED" gauge — same visual language as the in-game score
 * progress bar (gradient fill, shimmer sweep, amber pulse near sell-out).
 */
import React from 'react';
import GlowText from '../GlowText';

export default function SupplyProgress({ minted, max }) {
  const pct = max > 0 ? Math.min(100, (minted / max) * 100) : 0;
  const nearSoldOut = pct >= 90;

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-2">
        <span className="font-mono-hud text-dim text-xs tracking-widest">COLLECTION SUPPLY</span>
        <GlowText text={`${minted.toLocaleString()} / ${max.toLocaleString()}`} size={15} variant="cyan" mono className="stat-glow" />
      </div>
      <div
        className="w-full h-4 overflow-hidden"
        style={{
          background: 'rgba(0,229,255,0.08)',
          border: '1px solid var(--steel)',
          clipPath: 'polygon(8px 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%, 0 8px)',
        }}
      >
        <div
          className={nearSoldOut ? 'progress-near-win' : undefined}
          style={{
            position: 'relative',
            overflow: 'hidden',
            width: `${pct}%`,
            height: '100%',
            background: 'linear-gradient(90deg, var(--violet), var(--cyan))',
            boxShadow: '0 0 10px var(--cyan)',
            transition: 'width 0.4s ease-out',
          }}
        >
          <div className="progress-shimmer" />
        </div>
      </div>
      <div className="mt-1 text-right">
        <span className="font-mono-hud text-dim" style={{ fontSize: 11 }}>{pct.toFixed(1)}% CLAIMED</span>
      </div>
    </div>
  );
}
